import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import Checkbox from '@mui/material/Checkbox';

class GenericTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      statusSelectedRows: [],
    };
    this.onRowSelection = this.onRowSelection.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (this.props.selectedRows !== newProps.selectedRows) {
      this.setState({
        statusSelectedRows:
          newProps.selectedRows === null || newProps.selectedRows === undefined
            ? []
            : newProps.selectedRows,
      });
    }
  }

  onRowSelection(rowIndex, compName) {
    if (!this.props.selectable) return;

    let newSelectedRows = [...this.props.selectedRows];
    if (this.props.multiSelectable) {
      if (newSelectedRows.includes(rowIndex)) {
        newSelectedRows = newSelectedRows.filter((row) => row !== rowIndex);
      } else {
        newSelectedRows.push(rowIndex);
      }
    } else {
      newSelectedRows = [rowIndex];
    }

    this.setState(
      { statusSelectedRows: newSelectedRows },
      this.hidenHiddenItems
    );
    this.props.dispatch({
      type: types.FORM_INPUT,
      value: newSelectedRows,
      name: `${compName}SelectedRows`,
    });
  }

  onSelectAllRows = (event) => {
    const { checked } = event.target;

    let newSelectedRows = checked
      ? [...Array(this.props.rows.length).keys()]
      : [];
    this.setState({ statusSelectedRows: newSelectedRows }, () => {
      this.props.dispatch({
        type: types.FORM_INPUT,
        value: newSelectedRows,
        name: `${this.props.compName}SelectedRows`,
      });
    });
  };


  generateHeaders = (columns, selectable) => {
    return [
      <TableCell key="select-all-header" padding="checkbox" className={ selectable && this.props.enableSelectAll ? `showCheckbox` : `hideCheckbox`}>
        {
          selectable && this.props.enableSelectAll &&
          <Checkbox
            color="primary"
            indeterminate={
              this.state.statusSelectedRows.length > 0 &&
              this.state.statusSelectedRows.length < this.props.rows.length
            }
            checked={
              this.props.rows.length > 0 &&
              this.state.statusSelectedRows.length === this.props.rows.length
            }
            onChange={this.onSelectAllRows}
            inputProps={{
              "aria-label": "select all rows",
            }}
          />
        }
      </TableCell>,
      ...columns.map((column, i) => (
        <TableCell
          key={`head${i}`}
          className={`p-1 ${column.visibleMode ? `${column.visibleMode}` : ""}`}
          style={{ width: column.width }}
        >
          {column.sortable ? (
            <span
              className={
                column.key === this.props.sortBy && this.props.orderBy === "ASC"
                  ? "arrow_up"
                  : "arrow_down"
              }
              onClick={() => this.props.sort(column.key)}
            >
              {column.label}
            </span>
          ) : (
            <span>{column.label}</span>
          )}
        </TableCell>
      )),
    ];
  };

  generateRows = (columns, rows, _this, selectable) => {
    const selectedRows = _this.state.statusSelectedRows;

    if (rows && rows.length > 0) {
      return rows.map(function (row, i) {
        // handle the column data within each row
        let cells = columns.map((column, j) => {
          if (column.key === "checkbox") {
            return (
              <TableCell padding="checkbox">
                <Checkbox
                  color="primary"
                  indeterminate={selectedRows > 0 && selectedRows < rows.length}
                  checked={rows.length > 0 && selectedRows === rows.length}
                  onChange={(selectedRows) =>
                    this.onRowSelection(selectedRows, this.props.compName)
                  }
                  inputProps={{
                    "aria-label": "select all desserts",
                  }}
                />
              </TableCell>
            );
          } else {
            return (
              <TableCell
                style={{
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                  width: column.width,
                }}
                key={`col${i}${j}`}
                className={`p-1 ${column.visibleMode ? `${column.visibleMode}` : ""}`}
              >
                {row[column.key]}
              </TableCell>
            );
          }
        });
        return (
          <TableRow
            selected={selectedRows.indexOf(i) !== -1}
            role={"checkbox"}
            onClick={() => _this.onRowSelection(i, _this.props.compName)}
            aria-checked={selectedRows.indexOf(i) !== -1}
            key={`row${i}`}
            className="table-row"
          >
            <TableCell padding="checkbox" className={selectable ? `showCheckbox` : `hideCheckbox`}>
              {
                selectable &&
                <Checkbox
                  checked={selectedRows.indexOf(i) !== -1}
                  id={`checkRow-${i}`}
                  inputProps={{ "aria-labelledby": `table-checkbox-${row.id}` }}
                />
              }
            </TableCell>
            {cells}
          </TableRow>
        );
      });
    } else {
      return (
        <TableRow key="row0">
          <TableCell colSpan={20}>No data found.</TableCell>
        </TableRow>
      );
    }
  };

  showHiddenItems = (rowNumber) => {
    const table = document.getElementsByClassName(
      this.props.tableBodyClassName
    )[0];
    if (table && table.rows) {
      const row = table.rows.item(rowNumber);
      if (row) {
        let hiddenItems = row.querySelectorAll(".toggle-hidden");
        for (let index = 0; index < hiddenItems.length; index++) {
          hiddenItems[index].classList.remove("hidden");
        }
      }
    }
  };

  hidenHiddenItems = () => {
    const table = document.getElementsByClassName(
      this.props.tableBodyClassName
    )[0];
    if (table && table.rows && this.state.statusSelectedRows !== "all") {
      for (let index = 0; index < this.props.rows.length; index++) {
        if (this.state.statusSelectedRows.indexOf(index) === -1) {
          const row = table.rows.item(index);
          if (row) {
            let hiddenItems = row.querySelectorAll(".toggle-hidden");
            for (let index = 0; index < hiddenItems.length; index++) {
              hiddenItems[index].classList.add("hidden");
            }
          }
        }
      }
    }
  };

  render() {
    const p = this.props;
    const headerComponents = this.generateHeaders(p.columns, p.selectable);
    const rowComponents = this.generateRows(p.columns, p.rows, this, p.selectable);

    return (
      // <Table
      //     className={p.className}
      //     height={p.fixedHeight ? p.fixedHeight : null}
      //     fixedHeader={p.fixedHeader}
      //     fixedFooter={p.fixedFooter}
      //     selectable={p.selectable || false}
      //     onRowHover={(rowNumber) => this.showHiddenItems(rowNumber)}
      //     onRowHoverExit={(rowNumber) => this.hidenHiddenItems(rowNumber)}
      //     onRowSelection={(selectedRows) => this.onRowSelection(selectedRows, p.compName)}
      //     multiSelectable={p.multiSelectable || false}>
      //     <TableHeader
      //         className={`${p.tableHeaderClassName ? p.tableHeaderClassName : ''} tableHeaderClass`}
      //         displaySelectAll={p.displaySelectAll || false}
      //         adjustForCheckbox={p.adjustForCheckbox || false}
      //         enableSelectAll={p.enableSelectAll || false} >
      //         <TableRow>{headerComponents}</TableRow>
      //     </TableHeader>
      //     <TableBody
      //         className={`${p.tableBodyClassName ? p.tableBodyClassName : ''} tableBodyClass`}
      //         displayRowCheckbox={p.displayRowCheckbox || false}
      //         deselectOnClickaway={false}
      //         showRowHover={p.showRowHover || true}
      //         stripedRows={p.stripedRows}>
      //         {rowComponents}
      //     </TableBody>
      //     <TableFooter adjustForCheckbox={p.adjustForCheckbox || false} />
      // </Table>

      <TableContainer
        className={p.className}
        style={{ height: p.fixedHeight ? p.fixedHeight : "auto" }}
      >
        <Table className={p.className}>
          <TableHead
            className={`${p.tableHeaderClassName || ""} tableHeaderClass`}
          >
            <TableRow>{headerComponents}</TableRow>
          </TableHead>
          <TableBody className={`${p.tableBodyClassName || ""} tableBodyClass`}>
            {rowComponents}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

function mapStatetoProps(state, ownProps) {
  return {
    selectedRows: state.form[`${ownProps.compName}SelectedRows`] || [],
  };
}

export default connect(mapStatetoProps)(GenericTable);
